<template>
  <el-main class="userdetail">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{mType == '2' ? '行政采购项目' : '人力资源项目'}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: mType == '2' ? '/admin' : '/human' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item>项目详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="header">
      <div class="header-info">
        <h1>{{ `${projectArr.contract_name}` }}</h1>
        <p style="font-size: 20px; font-weight: 550;">{{ projectArr.manager_name }} {{ projectArr.manager_enname }}</p>
        <p v-if="projectArr.project_start_time != '0000-00-00'">项目时间: {{
          `${projectArr.project_start_time}-${projectArr.project_end_time}` }}</p>
        <p v-if="projectArr.finish_time != '0000-00-00'">项目完成时间：{{ projectArr.finish_time }}</p>
      </div>
      <div class="header-status">
        <div style="margin-right: 10px;">
          <el-button round style="text-align: center;" @click="statusShow = true" v-if="(mType == '2' ? NodeInclude('130') : NodeInclude('162')) && (!projectArr.is_hr_status || level == '1')">更新项目状态</el-button>
        </div>
        <div v-if="projectArr.status">
          <div class="button" :style="{ 'backgroundColor': dd.pro_status_c[projectArr.status].color }">{{
            dd.pro_status_c[projectArr.status].word }}</div>
        </div>
      </div>
    </div>
    <!-- 项目立项 -->
    <div class="base1">
      <h3 class="ntitle">项目信息</h3>
      <div class="operater" >
        <div class="linkbox" :class="{ 'grey': projectArr.application_init_time != '0000-00-00' }" @click="contractApply" v-if="(mType == '2' ? NodeInclude('131') : NodeInclude('161'))">
          {{ projectArr.application_init_time != '0000-00-00' ? '已申请' : '申请立项'}}
        </div>
      </div>
      <ul>
        <li>
          <p>
            <label>项目编号：</label>
            <a style="width: 100%;">
              <el-col :span="10">
                {{ projectArr.contract_no && projectArr.contract_no != 'TBD'  ? projectArr.contract_no : '暂无' }}
              </el-col>
              <el-col :span="6">
                <el-button round style="text-align: center;" @click="getProjectNo" :disabled="!canGetNo" v-if="(mType == '2' ? NodeInclude('132') : NodeInclude('160'))">自动获取</el-button>
              </el-col>
            </a>
          </p>
          <p>
            <label>项目创建时间：</label><a>{{ projectArr.create_time }}</a>
          </p>
          <p>
            <label>项目立项时间：</label><a>{{ projectArr.project_init_time }}</a>
          </p>
        </li>
        <li>
          <p></p>
          <p>
            <label>申请立项时间：</label><a>{{ projectArr.application_init_time }}</a>
          </p>
        </li>
      </ul>
    </div>
    <!-- 项目支出 -->
    <div class="table">
      <h3 class="ntitle">项目支出</h3>
      <div class="operater" v-if="sonList.length != 0 && (mType == '2' ? NodeInclude('133') : NodeInclude('171'))">
        <div class="linkline" @click="fillSon">编辑</div>
      </div>
      <template v-if="sonList.length == 0 && (mType == '2' ? NodeInclude('133') : NodeInclude('171'))">
        <div class="inblank">
          <el-button class="ibtn" icon="el-icon-plus" circle @click="fillSon"></el-button>
          <p>该项目暂无子项目，点击创建</p>
        </div>
      </template>
      <template v-else-if="sonList.length == 0">
        <div class="inblank">
          <p>该项目暂无子项目，如需新增预算请联系HR或高管创建</p>
        </div>
      </template>
      <template v-else-if="sonList.length != 0 && sonList[0].is_draft == '1'">
        <div class="inblank">
          <el-button class="ibtn" @click="fillSon">编辑草稿</el-button>
        </div>
      </template>
      <template v-else>
        <ul>
          <li>
            <p>
              <label>预算：</label><a>{{ totalBudget }}</a>
            </p>
          </li>
          <li>
            <p>
              <label>成本：</label><a>{{ totalCost }}</a>
            </p>
          </li>
          <li>
            <p>
              <label>已支付：</label><a>{{ totalPaid }}</a>
            </p>
          </li>
          <li>
            <p>
              <label>未支付：</label><a>{{ totalUnPaid }}</a>
            </p>
          </li>
        </ul>
        <div class="for grey" v-for="(item, index) in sonList" :key="index">
          <div class="for-title">子项目名称：{{ item.contract_name }}</div>
          <div class="switch" style="float: right;" v-if="(mType == '2' ? NodeInclude('277') : NodeInclude('299')) && projectArr.status != '5'">
            <label style="margin-right: 5px;">是否0成本</label>
            <div class="el-switch"
              :class="{ 'is-checked': item.is_zero == 2, 'cursor': item.payList.length != 0, 'super': level == 1 }"
              @click="switchShow(item)">
              <span class="el-switch__core"></span>
            </div>
          </div>
          <ul>
            <li>
              <p>
                <label>项目起止时间：</label><a>{{ item.start_time }} — {{ item.end_time }}</a>
              </p>
            </li>
          </ul>
          <div class="flex-box1">
            <div class="left">
              <ul class="left-ul">
                <li>
                  <p>
                    <label style="width: auto;">预算：</label><a>{{ item.sonTotalBudget }}</a>
                  </p>
                </li>
                <li>
                  <p>
                    <label style="width: auto;">成本：</label><a>{{ item.sonTotalCost }}</a>
                  </p>
                </li>
                <li>
                  <p>
                    <label style="width: auto;">已支付：</label><a>{{ item.sonTotalPaidAmount }}</a>
                  </p>
                </li>
                <li>
                  <p>
                    <label style="width: auto;">未支付：</label><a>{{ item.sonTotalNoPaidAmount }}</a>
                  </p>
                </li>
              </ul>
            </div>
            <div class="right" style="text-algin: right;">
              <el-button round icon="el-icon-plus" @click="addClick(item)" style="width:100px;margin: 15px;"
                v-if="item.is_zero == '1' && (((mType == '2' ? NodeInclude('134') : NodeInclude('170')) && item.canBudget) || level == 1) && projectArr.status != '5'">新增</el-button>
              <el-button round @click="showBudget(item)" style="width:100px; margin: 0;"
                v-if="item.is_zero == '1' && (mType == '2' ? NodeInclude('135') : NodeInclude('169')) && projectArr.status != '5'">提交预算</el-button>
            </div>
          </div>
          <div>
            <el-table :data="item.payList" stripe border scroll v-if="item.payList.length != 0" highlight-current-row>
              <el-table-column prop="service_type_name" label="服务类目" header-align="center" align="center" min-width="120">
              </el-table-column>
              <el-table-column prop="service_info" label="服务说明" header-align="center" align="left" min-width="300" />
              <el-table-column prop="pay_type" label="支付类别" header-align="center" align="center" min-width="80">
                <template slot-scope="scope">
                  {{ dd.pay_type[scope.row.pay_type] }}
                </template>
              </el-table-column>
              <el-table-column prop="vendor" label="供应商名称" header-align="center" align="center" min-width="250">
                <template slot-scope="scope">
                  <div class="linkwrap normal">
                    <el-link style="font-size: 12px;" @click="showVendor(scope.row)">{{ scope.row.vendorArr ?
                      scope.row.vendorArr.vendor : '点击选择供应商' }}</el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="contract_no" label="供应商合同编号" header-align="center" align="center" width="300">
                <template slot-scope="scope">
                  <div v-if="scope.row.contract_id == '-1'">无需合同</div>
                  <div class="linkwrap normal" v-else>
                    <el-link @click="showPurchase(scope.row)" style="font-size: 12px;">
                      {{ scope.row.vendorContractArr ? (scope.row.vendorContractArr.contract_no == 'TBD' ?
                        `${scope.row.vendorContractArr.contract_no}-${scope.row.vendorContractArr.contract_name}` :
                        scope.row.vendorContractArr.contract_no) : '点击选择供应商合同' }}
                    </el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="budget" label="预算" header-align="center" align="right" min-width="100" />
              <el-table-column prop="cost" label="成本" header-align="center" align="right" min-width="100" />
              <el-table-column prop="budget_status" label="预算审核" header-align="center" align="center" min-width="120">
                <template slot-scope="scope">
                  <span @click="budgetReson(scope.row)" style="cursor: pointer;">{{
                    dd.budget_status[scope.row.budget_status] }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="plan_amount" label="支付计划" header-align="center" align="right" min-width="250">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.planList" :key="index">
                    {{ item.plan_name ? item.plan_name + '：' : '' }} {{ item.plan_amount }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="pay_check_status" label="支付审核" header-align="center" align="center" min-width="200">
                <template slot-scope="scope">
                  <div v-for="(item, index) in scope.row.planList" :key="index" @click="payReson(item)"
                    style="cursor: pointer;">
                    {{ item.plan_name ? item.plan_name + '：' : '' }} {{ dd.pay_check_status[item.pay_check_status] }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="paidAmount" label="已支付" header-align="center" align="right" min-width="100" />
              <el-table-column prop="noPaidAmount" label="未支付" header-align="center" align="right" min-width="100" />
              <el-table-column prop="customer_contract_name" label="关联项目" header-align="center" align="center" min-width="200">
                <template slot-scope="scope">
                  <div class="linkwrap normal" v-if="Object.keys(scope.row.customerProjectArr).length != 0">
                    <el-link type='primary' class="link" @click="link(`/project/detail?id=${scope.row.customerProjectArr?.id}`)">{{ scope.row.customerProjectArr?.contract_name }}</el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="customer_contract_user" label="关联员工" header-align="center" align="center"
                min-width="200" v-if="mType == '3'">
                <template slot-scope="scope">
                  <p class="pdou"><span v-for="(item, index) in scope.row.customerUserArr" :key="index"> {{ item.realname
                  }}</span></p>
                </template>
              </el-table-column>
              <!-- 普通操作 -->
              <el-table-column prop="" label="操作" header-align="center" align="center" min-width="200" fixed="right"
                v-if="projectArr.status != '5' && !(mType == '2' ? (NodeInclude('136') || NodeInclude('340') || NodeInclude('138')) : (NodeInclude('168') || NodeInclude('341') || NodeInclude('166')))">
                <template slot-scope="scope">
                  <div class="linkwrap">
                    <span class="link" @click="delClick(scope.row)" v-if="(mType == '2' ? NodeInclude('276') : NodeInclude('298'))">删除</span>
                    <span class="link" @click="applyPayClick(scope.row)" v-if="(mType == '2' ? NodeInclude('137') : NodeInclude('167'))">申请支付</span>
                    <span class="link" @click="updatePayClick(scope.row)" v-if="(mType == '2' ? NodeInclude('139') : NodeInclude('165'))">更新支付状态</span>
                    <span class="link" @click="viewClick(scope.row)" v-if="(mType == '2' ? NodeInclude('134') : NodeInclude('170'))">编辑</span>
                  </div>
                </template>
              </el-table-column>
              <!-- 更多操作 -->
              <el-table-column prop="" label="操作" header-align="center" align="center" min-width="200" fixed="right"
                v-else-if="projectArr.status != '5' && (mType == '2' ? (NodeInclude('136') || NodeInclude('340') || NodeInclude('138')) : (NodeInclude('168') || NodeInclude('341') || NodeInclude('166')))">
                <template slot-scope="scope">
                  <div class="linkwrap">
                    <span class="link"
                      :class="{ 'grey': ((scope.row.budget_status == '3' || scope.row.budget_status == '4') && level != 1) }"
                      @click="budgetCheckClick(scope.row)" v-if="(mType == '2' ? (NodeInclude('136') || NodeInclude('340')) : (NodeInclude('168') || NodeInclude('341')))">预算审核</span>
                    <span class="link" @click="payCheckClick(scope.row)" v-if="(mType == '2' ? NodeInclude('137') : NodeInclude('166'))">支付审核</span>
                    <span class="link" @click="viewClick(scope.row)" v-if="(mType == '2' ? NodeInclude('134') : NodeInclude('170'))">编辑</span>
                    <el-dropdown size="mini" @command="(command) => handleCommandMore(command, scope.row)">
                      <span class="link" style="cursor: pointer;">更多</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="delClick" v-if="(mType == '2' ? NodeInclude('276') : NodeInclude('298'))">删除</el-dropdown-item>
                        <el-dropdown-item command="applyPayClick" v-if="(mType == '2' ? NodeInclude('137') : NodeInclude('167'))">申请支付</el-dropdown-item>
                        <el-dropdown-item command="updatePayClick" v-if="(mType == '2' ? NodeInclude('139') : NodeInclude('165'))">更新支付状态</el-dropdown-item>
                        <el-dropdown-item command="changeClick" v-if="(mType == '2' ? NodeInclude('141') : NodeInclude('163'))">移动</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
              <!-- 项目结束 -->
              <el-table-column prop="" label="操作" header-align="center" align="center" min-width="80" fixed="right" v-else>
                <template slot-scope="scope">
                  <div class="linkwrap">
                    <span class="link" @click="viewClick(scope.row)" v-if="(mType == '2' ? NodeInclude('134') : NodeInclude('170'))">编辑</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-table :data="emptyList" v-else> </el-table>
          </div>
        </div>
      </template>
    </div>
    <!-- 项目动态 -->
    <div class="history">
      <h3 class="ntitle">项目动态</h3>
      <el-form ref="trackForm" :model="trackForm" style="float:right;" v-if="projectArr.status != '5'">
        <el-form-item label="" prop="track_event">
          <el-col :span="20">
            <el-select v-model="trackForm.event_id" placeholder="请选择流程" style="margin-right: 0; width: 100%;"
              @change="trackChange">
              <el-option label="全部流程" value="0"></el-option>
              <el-option label="预算管理" value="9"></el-option>
              <el-option label="供应商合同" value="3"></el-option>
              <el-option label="支付管理" value="4"></el-option>
              <el-option label="项目状态" value="7"></el-option>
              <!-- 行政管理 -->
              <el-option label="项目管理" value="10" v-if="mType == '2'"></el-option>
              <!-- 人力资源管理 -->
              <el-option label="项目管理" value="11" v-if="mType == '3'"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <ul class="linehead">
        <li>时间</li>
        <li>操作人</li>
        <li>流程</li>
        <li>详情</li>
      </ul>
      <div class="timeline">
        <el-timeline>
          <el-timeline-item :timestamp="compDate(item)" placement="top" v-for="(item, index) in myTrackList" :key="index"
            :class="{ child: !item.parent }" :icon="item.icon" :color="item.color">
            <!-- <div class="ico-edit" @click="setTrackId(item)" v-if="projectArr.status != '5'"><i class="el-icon-edit"></i></div>-->
            <div class="ico-edit" v-if="projectArr.status != '5'">
              <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
                <i class="el-icon-edit" @click="setTimeForm(item)"></i>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="a" v-if="(mType == '2' ? NodeInclude('142') : NodeInclude('172'))">新增</el-dropdown-item>
                    <el-dropdown-item command="b" v-if="(mType == '2' ? NodeInclude('142') : NodeInclude('172'))">编辑</el-dropdown-item>
                    <el-dropdown-item command="c" v-if="(mType == '2' ? NodeInclude('278') : NodeInclude('300'))">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
            <div class="mycard" :class="{ active: parentActive(item), parent: item.parent }" @click="trigger(item)">
              <!-- {{item}} -->
              <i class="point" v-if="item.point">+{{ item.point }}</i>
              <div v-if="!item.parent">
                <ul class="ul">
                  <li>
                    <span>{{ item.bkUserArr ? `${item.bkUserArr.realname} ${item.bkUserArr.en_name}` : '暂无' }}</span>
                  </li>
                  <li>
                    <span>{{ item.eventName }}</span>
                  </li>
                  <li v-html="item.info"></li>
                </ul>
              </div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>

    <el-dialog :title="currCost.is_zero == 1 ? '请确认该子项目是否修改为0成本？' : '修改为非0成本'" :visible.sync="costShow" width="600px">
      <ul class="aul" style="padding:0">
        <li>
          <span style="width: 80%;text-align:left; line-height: 30px;">子项目名称：{{ currCost.contract_name }}</span><br>
          <span style="width: 80%;text-align:left; line-height: 30px;">{{ currCost.is_zero == 1 ? '注意：确认后将无法为该项目新增预算' :
            '' }}</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="costShow = false">取 消</el-button>
        <el-button type="primary" @click="handleCost">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="项目状态" :visible.sync="statusShow" width="600px">
      <div style="padding: 30px 0;">
        <el-col :span="24">
          <el-radio-group v-model="currstatus">
            <el-radio label="1">未开始</el-radio>
            <el-radio label="2">进行中</el-radio>
            <el-radio label="3">项目终止</el-radio>
            <el-radio label="4">已完成</el-radio>
            <el-radio label="5">已归档</el-radio>
          </el-radio-group>
        </el-col>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statusShow = false">取 消</el-button>
        <el-button type="primary" @click="handleStatus">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="审核信息" :visible.sync="resonShow" width="600px">
      <ul class="aul" style="padding:0">
        <li>
          <span style="white-space: pre-wrap;">{{ currReason.reason }}</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resonShow = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="timeForm.option == 1 ? '新增合同动态' : '编辑合同动态'" :visible.sync="trackShow" width="600px">
      <el-form ref="timeForm" :model="timeForm" label-width="220px" label-position="left" class="ulform">
        <el-form-item label="选择时间：" prop="create_time">
          <el-col :span="24">
            <el-date-picker v-model="timeForm.create_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择时间" style="width:100%;">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="选择操作人：" prop="bk_uid">
          <el-col :span="24">
            <el-select v-model="timeForm.bk_uid" placeholder="请选择" clearable filterable style="width:100%;">
              <el-option :label="`${v.realname}`" :value="v.id" v-for="(v, i) in userList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="选择流程：" prop="event_id">
          <el-col :span="24">
            <el-select v-model="timeForm.event_id" placeholder="请选择" style="width: 100%;">
              <el-option label="全部流程" value="0"></el-option>
              <el-option label="预算管理" value="9"></el-option>
              <el-option label="供应商合同" value="3"></el-option>
              <el-option label="支付管理" value="4"></el-option>
              <el-option label="项目状态" value="7"></el-option>
              <!-- 行政管理 -->
              <el-option label="项目管理" value="10" v-if="mType == '2'"></el-option>
              <!-- 人力资源管理 -->
              <el-option label="项目管理" value="11" v-if="mType == '3'"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="备注：" prop="info">
          <el-col :span="24">
            <el-input style="width: 100%;" type="textarea" spellcheck="false" :autosize="{ minRows: 4 }"
              placeholder="请输入内容" v-model="timeForm.info">
            </el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="trackShow = false">取 消</el-button>
        <el-button type="primary" @click="handleTrack">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="删除合同动态" :visible.sync="delTrackShow" width="600px">
      <ul class="aul ulist" style="padding:0; min-height: 100px;">
        <li>
          <span>时间：</span>
          <span>{{ timeForm.create_time }}</span>
        </li>
        <li>
          <span>操作人：</span>
          <span>{{ timeForm.bkUserArr ? timeForm.bkUserArr.realname : '暂无' }}</span>
        </li>
        <li>
          <span>项目状态：</span>
          <span>{{ dd.track_type[timeForm.event_id] }}</span>
        </li>
        <li>
          <span>详情：</span>
          <span v-html="timeForm.info"></span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delTrackShow = false">取 消</el-button>
        <el-button type="primary" @click="deleteTrack">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="删除提醒" :visible.sync="delShow" width="800px">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>您是否确定删除该预算</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delShow = false">取 消</el-button>
        <el-button type="primary" @click="handleDel">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提交预算" :visible.sync="budgetShow" width="1000px">
      <el-table :data="budgetPayList" stripe border scroll highlight-current-row>
        <el-table-column prop="service_type" label="服务类目" header-align="center" align="center" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.service_type_name }}
          </template>
        </el-table-column>
        <el-table-column prop="service_info" label="服务说明" header-align="center" align="left" min-width="300" />
        <el-table-column prop="vendor" label="供应商名称" header-align="center" align="center" min-width="200">
          <template slot-scope="scope">
            {{ scope.row.vendorArr.vendor }}
          </template>
        </el-table-column>
        <el-table-column prop="budget" label="预算" header-align="center" align="center" min-width="300"></el-table-column>
        <el-table-column prop="cost" label="成本" header-align="center" align="center" min-width="300">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.planList" :key="index">
              {{ item.plan_name ? item.plan_name + '：' : '' }}{{ item.plan_amount }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 20px 0;">温馨提示：您是否确定提交{{ budgetTotal }}条预算</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="budgetShow = false">取 消</el-button>
        <el-button type="primary" @click="handleBudget">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="支付申请" :visible.sync="payShow" width="600px" v-if="currToPay">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>子项目名称：</span>
          <span>{{ currToPay.son_contract_name }}</span>
        </li>
        <li>
          <span>服务类目：</span>
          <span>{{ currToPay.service_type_name }}</span>
        </li>
        <li>
          <span>服务说明：</span>
          <span style="white-space: pre-wrap;">{{ currToPay.service_info }}</span>
        </li>
        <li>
          <span>供应商名称：</span>
          <span>{{ currToPay.vendorArr ? currToPay.vendorArr.vendor : '暂无' }}</span>
        </li>
        <li>
          <span>支付类别：</span>
          <span>{{ dd.pay_type[currToPay.pay_type] }}</span>
        </li>
        <el-form ref="payForm" :model="payForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="选择支付计划：" prop="plan_id">
            <el-col :span="24">
              <el-select v-model="payForm.plan_id" placeholder="请选择" @change="planChange" style="width:100%;">
                <el-option :label="v.plan_name" :value="v.id" v-for="(v, i) in currToPay.planList" :key="i"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="计划付款金额：" prop="plan_amount">
            <el-col :span="24">
              {{ payForm.plan_amount }}
            </el-col>
          </el-form-item>
          <el-form-item label="计划付款时间：" prop="hope_pay_time">
            <el-col :span="24">
              {{ payForm.hope_pay_time }}
            </el-col>
          </el-form-item>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payShow = false">取 消</el-button>
        <el-button type="primary" @click="handleApply">申 请</el-button>
      </span>
    </el-dialog>

    <el-dialog title="预算审核" :visible.sync="budgetCheckShow" width="600px" v-if="currbudgetCheck">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>预算：</span>
          <span>{{ currbudgetCheck.budget }}</span>
        </li>
        <li>
          <span>采购事由：</span>
          <span style="white-space: pre-wrap;">{{ currbudgetCheck.service_info }}</span>
        </li>
        <li>
          <span>服务类目：</span>
          <span>{{ currbudgetCheck.service_type_name }}</span>
        </li>
        <li>
          <span>申请人：</span>
          <span>{{ manager_name }}</span>
        </li>
        <el-form ref="bugetCheckForm" :model="bugetCheckForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="预算审核：" prop="budget_status">
            <el-col :span="24">
              <el-radio-group v-model="bugetCheckForm.budget_status">
                <el-radio label="3">通过</el-radio>
                <el-radio label="4">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <template v-if="bugetCheckForm.budget_status == '3'">
            <el-form-item label="" prop="budget_check_info">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="bugetCheckForm.budget_check_info">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
          <template v-if="bugetCheckForm.budget_status == '4'">
            <el-form-item label="" prop="budget_check_reason">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="bugetCheckForm.budget_check_reason">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="budgetCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handleBudgetCheck">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="支付审核" :visible.sync="payCheckShow" width="600px" v-if="currPayCheck">
      <ul class="aul ulist" style="padding:0;">
        <el-form ref="payCheckForm" :model="payCheckForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="选择支付计划：" prop="plan_id">
            <el-col :span="24">
              <el-select v-model="payCheckForm.plan_id" placeholder="请选择" @change="planCheckChange" style="width:100%;">
                <el-option :label="v.plan_name" :value="v.id" v-for="(v, i) in currPayCheck.planList"
                  :key="i"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="计划支付金额：" prop="plan_amount">
            <el-col :span="24">
              {{ payCheckForm.plan_amount }}
            </el-col>
          </el-form-item>
          <el-form-item label="申请人：" prop="">
            <el-col :span="24">
              {{ manager_name }}
            </el-col>
          </el-form-item>
          <el-form-item label="审核：" prop="pay_check_status">
            <el-col :span="24">
              <el-radio-group v-model="payCheckForm.pay_check_status">
                <el-radio label="3">通过</el-radio>
                <el-radio label="4">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <template v-if="payCheckForm.pay_check_status == '3'">
            <el-form-item label="" prop="pay_check_info">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="payCheckForm.pay_check_info">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
          <template v-if="payCheckForm.pay_check_status == '4'">
            <el-form-item label="" prop="pay_check_reason">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="payCheckForm.pay_check_reason">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handlePayCheck">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="立项申请" :visible.sync="conShow" width="400px">
      <ul class="aul" style="padding:0">
        <li>
          <span>请确认是否进行立项申请？</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="conShow = false">取 消</el-button>
        <el-button type="primary" @click="handleConApply">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择供应商" :visible.sync="vendorShow" width="500px">
      <el-form ref="vendorForm" :model="vendorForm" label-width="150px" label-position="left" class="ulform">
        <el-form-item label="选择供应商名称：" prop="vendor_id">
          <el-col :span="24">
            <el-select v-model="vendorForm.vendor_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="vendorChange" @clear="vendorChange" clearable filterable>
              <el-option :label="v.vendor" :value="v.id" v-for="(v, i) in vendorList" :key="i"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showNewVendor">没有相关供应商，点击下载《供应商登记表》</el-button>
      </span>
    </el-dialog>

    <el-dialog title="下载供应商登记表" :visible.sync="newVendorShow" width="500px">
      <span>按照登记表补充供应商信息，联系Jaunty新增</span>
      <span slot="footer" class="dialog-footer">
        <el-link class="dialog-download" :href="`http://${host}/images/download/供应商信息登记表（个人）20230412.xlsx`"
          target="_blank">个人供应商</el-link>
        <el-link class="dialog-download" :href="`http://${host}/images/download/供应商信息登记表（公司）20230412.xlsx`"
          target="_blank">公司供应商</el-link>
      </span>
    </el-dialog>

    <el-dialog title="选择供应商合同" :visible.sync="purchaseShow" width="500px">
      <el-form ref="vendorForm" :model="vendorForm" label-width="150px" label-position="left" class="ulform">
        <el-form-item label="选择供应商合同：" prop="contract_id">
          <el-col :span="24">
            <el-select v-model="vendorForm.contract_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
              @change="purchaseChange" filterable>
              <el-option :label="v.contract_no + '-' + v.contract_name" :value="v.id" v-for="(v, i) in purchaseList"
                :key="i" :disabled="v.beChoosed == '1'"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addPurchase(vendorForm)">没有相关合同，新建供应商合同 </el-button>
      </span>
    </el-dialog>

    <el-dialog title="移动支出到对应子项目" :visible.sync="changeShow" width="600px">
      <ul class="aul ulist" style="padding:0; height: 200px;">
        <li>
          <span>服务类目：</span>
          <span>{{ changeForm.service_type_name }}</span>
        </li>
        <li>
          <span>服务说明：</span>
          <span>{{ changeForm.service_info }}</span>
        </li>
        <li>
          <span>预算：</span>
          <span>{{ changeForm.budget }}</span>
        </li>
        <el-form ref="bugetCheckForm" :model="changeForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="移动到子项目：" prop="budget_status">
            <el-col :span="24">
              <el-select v-model="changeForm.son_project_id" placeholder="请选择" style="margin-right: 0; width: 100%;"
                clearable filterable>
                <el-option :label="v.contract_name" :value="v.id" v-for="(v, i) in sonList" :key="i"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeShow = false">取 消</el-button>
        <el-button type="primary" @click="changeOther">确定移动</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import * as api from '@/api'
import { thousands, antiThousands } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'ahView',
  data() {
    return {
      nodeLimtList: [],
      showMore: false,
      mType: '',
      userList: [],
      host: '',
      is_apply: '',
      manager_name: '',
      level: '',
      canGetNo: true,
      billList: [],
      projectArr: {
        status: '',
      },
      sonList: [
        { amount: '', payList: [], },
      ],
      vendorList: [],
      purchaseList: [],
      totalBudget: 0,
      totalCost: 0,
      totalPaid: 0,
      totalUnPaid: 0,
      payForm: {
        plan_id: '',
        hope_pay_time: '',
        plan_amount: '',
      },
      bugetCheckForm: {
        option: 2,
        pay_id: '',
        budget_status: '4',
        budget_check_info: '',
        budget_check_reason: '',
      },
      payCheckForm: {
        plan_id: '', hope_pay_time: '', apply_amount: '', plan_amount: '', pay_check_status: '4', pay_check_reason: '', pay_check_info: '',
      },
      trackForm: {
        project_id: '',
        event_id: '',
      },
      delTrackShow: false,
      timeForm: {
        track_id: '',
        create_time: '',
        bk_uid: '',
        event_id: '',
        info: '',
        option: 1,
      },
      trackList: [],
      emptyList: [],//0成本数组
      total: 0,
      p: 1,
      perPage: 30,
      budgetShow: false,
      budgetPayList: [],
      budgetTotal: '',
      costShow: false,
      currCost: {//son数组

      },
      statusShow: false,
      currstatus: '',
      resonShow: false,
      currReason: {//当前原因数组

      },
      trackShow: false,
      currTrack: {//当前动态

      },
      delShow: false,
      currDel: {//当前删除的数组

      },
      payShow: false,
      currToPay: {//当前支付申请数组

      },
      budgetCheckShow: false,
      currbudgetCheck: {//当前预算审核

      },
      payCheckShow: false,
      currPayCheck: {//当前支付审核

      },
      conShow: false,
      newForm: {},
      vendorShow: false,
      vendorForm: {}, //更改供应商
      changeShow: false,
      changeForm: {},
      newVendorShow: false,
      purchaseShow: false,
    }
  },
  mounted() {
    this.getUserList()
  },
  computed: {
    parentActive() {
      return (item) => {
        return item.parent && item.active
      }
    },
    myTrackList() {
      return this.trackList.filter((item) => item)
    },
  },
  created() {
    this.host = window.location.host.search('192') === -1 ? window.location.host : `devoa.minuteschina.com`
    this.mType = this.query.mType
    this.query.id && this.getProjectDetail(this.query.id)
  },
  watch: {

  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    async getUserList() {
      this.$fly
        .post('apiAccount_getUserList.html', {
          per_page: 5000,
        })
        .then((res) => {
          this.userList = res.itemList
        })
    },
    getProjectDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      api.getAdminProjectDetail({ id: id }).then((res) => {
        this.billList = res.billList
        this.projectArr = res.item_info
        this.sonList = res.son_list
        this.trackList = res.track_list
        //is_apply
        this.is_apply = this.projectArr.is_apply
        this.manager_name = this.projectArr.manager_name
        delete this.projectArr.is_apply
        this.projectArr.contract_amount = thousands(Number(this.projectArr.contract_amount))
        this.projectArr.tax = thousands(Number(this.projectArr.tax))
        //清空计算值
        this.totalBudget = 0
        this.totalCost = 0
        this.totalPaid = 0
        this.totalUnPaid = 0
        //支出总值
        this.sonList.costNum = 0
        this.sonList.budgetNum = 0
        this.sonList.zeroBen = 0
        for (let i = 0; i < this.sonList.length; i++) {
          const _budget = Number(this.sonList[i].sonTotalBudget);
          if (!isNaN(_budget) && this.sonList[i].is_zero != '2') {
            this.totalBudget += _budget
          }
          else  {
            this.sonList.budgetNum += 1 //'暂无'
          }
          const _cost = Number(this.sonList[i].sonTotalCost);
          if (!isNaN(_cost) && this.sonList[i].is_zero != '2') {
            this.totalCost += _cost
          }
          else  {
            this.sonList.costNum += 1 //有'暂无'
          }
          const _paid = Number(this.sonList[i].sonTotalPaidAmount);
          this.totalPaid += _paid
          const _unpaid = Number(this.sonList[i].sonTotalNoPaidAmount);
          this.totalUnPaid += _unpaid
          //payList为空且为0成本，显示是0
          if (this.sonList[i].is_zero == '2') {
            this.sonList.zeroBen += 1
          }          
        }
        this.totalBudget = this.totalBudget == 0 && (this.sonList.budgetNum == this.sonList.length) ? (this.sonList.zeroBen == this.sonList.length ? '0.00' : '暂无') : thousands(this.totalBudget)
        this.totalCost = this.totalCost == 0 && (this.sonList.costNum == this.sonList.length) ? (this.sonList.zeroBen == this.sonList.length ? '0.00' : '暂无') : thousands(this.totalCost)
        this.totalPaid = thousands(this.totalPaid)
        this.totalUnPaid = thousands(this.totalUnPaid)
        this.sonList = this.sonList.map((item) => {
          item.amount = thousands(Number(item.amount))
          item.sonTotalBudget = item.sonTotalBudget != '暂无' ? thousands(Number(item.sonTotalBudget)) : item.sonTotalBudget 
          item.sonTotalCost = item.sonTotalCost != '暂无' ? thousands(Number(item.sonTotalCost)) : item.sonTotalCost  
          item.sonTotalNoPaidAmount = thousands(Number(item.sonTotalNoPaidAmount))
          item.sonTotalPaidAmount = thousands(Number(item.sonTotalPaidAmount))
          return item
        })
        for (let i = 0; i < this.sonList.length; i++) {
          let _payList = this.sonList[i].payList
          this.sonList[i].canBudget = true
          for (let j = 0; j < _payList.length; j++) {
            let pay = _payList[j]
            pay.budget = thousands(Number(pay.budget))
            pay.cost = pay.cost != '暂无' ? thousands(Number(pay.cost)) : pay.cost 
            pay.noPaidAmount = thousands(Number(pay.noPaidAmount))
            pay.paidAmount = thousands(Number(pay.paidAmount))
            pay.vendorTotalInvoice = thousands(Number(pay.vendorTotalInvoice))
            if (pay.budget_status != 1) {
              this.sonList[i].canBudget = false
            }
          }
        }
        this.currstatus = JSON.parse(JSON.stringify(this.projectArr.status))
        this.canGetNo = this.projectArr.contract_no == '' || this.projectArr.contract_no == 'TBD' ? true : false
        setTimeout(() => {
          //权限
          this.level = store.state.level
          this.realName = store.state.realName
        }, 200);
      })
    },
    delClick(item) {//删除支付
      this.currDel = item
      if (this.level != 1) {
        if (this.currDel.budget_status == '2') {
          this.$message.error('待审核的预算不可删除!')
          return false
        }
        if (this.currDel.budget_status == '3') {
          this.$message.error('已审核的预算申请不可删除!')
          return false
        }
      }
      this.delShow = true
    },
    handleDel() {
      this.$fly
        .post('apiProject_delPay.html', {
          pay_id: this.currDel.id,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.delShow = false
          this.getProjectDetail(this.query.id)
        })
    },
    applyPayClick(item) {//申请支付
      const sonList = this.sonList
      for (let i = 0; i < sonList.length; i++) {
        const element = sonList[i];
        if (element.id == item.son_project_id) {
          this.currToPay = {
            ...item,
            son_contract_name: element.contract_name,
          }
        }
      }
      if (this.level != 1) {
        if (this.currToPay.budget_status != '3') {
          this.$message.error('请等待预算审核通过!')
          return false
        }
      }
      if (!this.currToPay.vendorArr) {
        this.$message.error('请选择供应商!')
        return false
      }
      if (this.currToPay.pay_type == '1') {
        this.currToPay.planList = this.currToPay.planList.map((item) => {//只展示未申请的计划
          return item.pay_check_status == '1' ? item : ''
        }).filter((s) => { return s })
      }
      this.payShow = true
      this.payForm = { plan_id: '', hope_pay_time: '', plan_amount: '', apply_amount: '' }
    },
    planChange() {
      this.currToPay.planList.forEach(item => {
        if (item.id == this.payForm.plan_id) {
          this.payForm = {
            ...this.payForm,
            plan_name: item.plan_name,
            apply_amount: item.plan_amount,
            plan_amount: item.plan_amount,
            hope_pay_time: item.hope_pay_time,
          }
        }
      });
    },
    handleApply() {//提交支付申请
      for (let i = 0; i < this.currToPay.planList.length; i++) {
        const id = this.currToPay.planList[i].id;
        const status = this.currToPay.planList[i].pay_check_status;
        if (status == '2' && id == this.payForm.plan_id) {
          this.$message.error('请勿重复申请!')
          return false
        }
        else if (status == '3' && id == this.payForm.plan_id) {
          this.$message.error('该支付计划审核已通过！')
          return false
        }
        else if (status == '4' && id == this.payForm.plan_id) {
          this.$message.error('该支付计划审核不通过，请修改计划重新提交!')
          return false
        }
      }
      //预支特殊情况
      if (this.currToPay.pay_type == '2' && this.payForm.plan_name == '结算') {
        console.log(this.currToPay.planList);
        if (this.currToPay.planList[0].pay_status != '3') {
          this.$message.error('请先等待预支完成支付')
          return false
        }
      }
      this.$fly
        .post('apiProject_updatePayPlan.html', {
          ...this.payForm,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.payShow = false
          this.getProjectDetail(this.query.id)
        })
    },
    budgetCheckClick(item) {//预算审核
      const sonList = this.sonList
      for (let i = 0; i < sonList.length; i++) {
        const element = sonList[i];
        if (element.id == item.son_project_id) {
          this.currbudgetCheck = {
            ...item,
            son_contract_name: element.contract_name,
          }
        }
      }
      const status = this.currbudgetCheck.budget_status;
      if (status == '1') {
        this.$message.error('本条记录还未提交审核!')
        return false
      }
      if (this.level != 1) {
        if (status == '3' || status == '4') {
          this.$message.error('本条记录已审核!')
          return false
        }
      }
      this.bugetCheckForm.pay_id = item.id
      this.budgetCheckShow = true
    },
    handleBudgetCheck() {
      let temp = JSON.parse(JSON.stringify(this.bugetCheckForm))
      delete temp.pay_type
      this.$fly
        .post('apiProject_addUpdatePay.html', {
          ...temp,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.budgetCheckShow = false
          this.bugetCheckForm.budget_status = '4' //还原审核状态
          this.getProjectDetail(this.query.id)
        })
    },
    payCheckClick(item) {//支付审核
      const sonList = this.sonList
      for (let i = 0; i < sonList.length; i++) {
        const element = sonList[i];
        if (element.id == item.son_project_id) {
          this.currPayCheck = {
            ...item,
            son_contract_name: element.contract_name,
          }
        }
      }
      if (this.level != 1) {
        if (this.currPayCheck.budget_status != '3') {
          this.$message.error('请等待预算审核通过!')
          return false
        }
        this.currPayCheck.planList = this.currPayCheck.planList.map((item) => {//只取可以审核的订单
          return item.pay_check_status == '2' ? item : ''
        }).filter((s) => { return s })
      }
      this.payCheckShow = true
      this.payCheckForm = { plan_id: '', hope_pay_time: '', apply_amount: '', plan_amount: '', pay_check_status: '4', pay_check_reason: '', pay_check_info: '', }
    },
    planCheckChange() {
      this.currPayCheck.planList.forEach(item => {
        if (item.id == this.payCheckForm.plan_id) {
          this.payCheckForm = {
            ...this.payCheckForm,
            apply_amount: item.apply_amount,
            plan_amount: item.plan_amount,
            hope_pay_time: item.hope_pay_time,
          }
        }
      });
    },
    handlePayCheck() {
      this.$fly
        .post('apiProject_updatePayPlan.html', {
          ...this.payCheckForm,
          apply_amount: '',
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.payCheckShow = false
          this.payCheckForm.pay_check_status = '4' //还原审核状态
          this.payCheckForm.pay_check_info = '' //还原审核状态
          this.payCheckForm.pay_check_reason = '' //还原审核状态
          this.getProjectDetail(this.query.id)
        })
    },
    addClick(item) {
      if (item.is_zero == '2') {
        return false
      }
      this.$router.push({
        path: '/adminPay/add',
        query: { pid: item.project_id, sid: item.id, mType: this.mType },
      })
    },
    showBudget(item) {
      if (!this.projectArr.contract_no || this.projectArr.contract_no == 'TBD') {
        this.$message.error('该项目暂未立项，无法提交预算')
        return false
      }
      if (item.is_zero == '2') {
        return false
      }
      const sid = item.id
      const toCheckList = []
      for (let i = 0; i < this.sonList.length; i++) {
        const _sid = this.sonList[i].id;
        if (sid == _sid) {
          const _payList = this.sonList[i].payList;
          for (let j = 0; j < _payList.length; j++) {
            const ele = _payList[j];
            if (ele.budget_status == '1' || ele.budget_status == '0') {
              toCheckList.push(ele.id)
            }
          }
        }
      }
      if (!toCheckList.length) {
        this.$message.error('暂无需要提交审核的支付计划!')
        return false
      }
      this.toCheckList = toCheckList
      this.$fly
        .post('apiProject_getPayList.html', { pay_id_str: this.toCheckList.toString(), mType: this.mType, })
        .then((res) => {
          this.budgetPayList = res.itemList.map((item) => {
            item.cost = thousands(item.cost)
            return item
          })
          this.budgetTotal = this.toCheckList.length
          this.budgetShow = true
        })
    },
    handleBudget() {
      this.$fly
        .post('apiProject_submitBudget.html', { pay_id_str: this.toCheckList.toString(), mType: this.mType, })
        .then((res) => {
          console.log(res);
          this.budgetShow = false
          this.getProjectDetail(this.query.id)
        })
    },
    updatePayClick(item) {
      const toCheckList = []
      const ele = item.planList;
      for (let k = 0; k < ele.length; k++) {
        const pay_check_status = ele[k].pay_check_status;
        const eleid = ele[k].id;
        if (pay_check_status == '3') {
          toCheckList.push(eleid)
        }
      }
      if (toCheckList.length == '0') {
        this.$message.error('暂无可以更新的支付计划!')
        return false
      }
      this.$router.push({
        path: '/project/pay',
        query: {
          id: item.id,
          cid: this.projectArr.id,
          kind: 1,
          mType: this.mType,
        },
      })
    },
    viewClick(item) {
      this.$router.push({
        path: '/adminPay/view',
        query: { id: item.id, cid: this.projectArr.id, mType: this.mType },
      })
    },
    changeClick(item) {
      const { id, service_info, service_type } = item
      const budget = JSON.parse(JSON.stringify(item.budget))
      this.changeForm = {
        pay_id: id,
        son_project_id: '',
        service_info,
        service_type,
        budget: antiThousands(budget),
      }
      this.changeShow = true
    },
    changeOther() {
      return new Promise((resolve, reject) => {
        this.$fly
          .post('apiProject_addUpdatePay.html', {
            ...this.changeForm,
            mType: this.mType,
            option: 2,
          })
          .then((res) => {
            if (res.status === 200) {
              this.$message.success('支付计划已更新')
              this.changeShow = false
              this.query.id && this.getProjectDetail(this.query.id)
              resolve(res)
            }
            else {
              reject('fail')
            }
          })
      })
    },
    budgetReson(item) {
      if (item.budget_status == '3') {
        this.resonShow = true
        this.currReason.reason = item.budget_check_info != '' ? item.budget_check_info : '暂无'
      }
      if (item.budget_status == '4') {
        this.resonShow = true
        this.currReason.reason = item.budget_check_reason != '' ? item.budget_check_reason : '暂无'
      }
    },
    payReson(item) {
      if (item.pay_check_status == '3') {
        this.resonShow = true
        this.currReason.reason = item.pay_check_info != '' ? item.pay_check_info : '暂无'
      }
      if (item.pay_check_status == '4') {
        this.resonShow = true
        this.currReason.reason = item.pay_check_reason != '' ? item.pay_check_reason : '暂无'
      }
    },
    handleCurrentChange(p) {
      this.p = p

      this.getTrackList()
    },
    compDate(item) {
      return item.smartTime + '' + item.weekTime
    },
    trigger(item) {
      let date = item.date || {}
      this.trackList = this.trackList.map((v) => {
        if (v.date === date) {
          v.active = !v.active
        }
        return v
      })
    },
    trackChange(v) {
      this.$fly
        .post('apiProject_getTrackList.html', {
          project_id: this.query.id,
          event_id: v,
          mType: this.mType,
        })
        .then((res) => {
          this.trackList = res.trackList
        })
    },
    //0成本弹层
    switchShow(item) {
      if (item.payList.length != 0) {
        return false
      }
      else {
        if (this.level != 1 && item.is_zero == 2) {
          return false
        }
        else {
          const { contract_name, id, is_zero } = item
          this.currCost = { contract_name, id, is_zero }
          this.costShow = true
        }
      }
    },
    //0成本
    handleCost() {
      this.$fly
        .post('apiProject_setSonProjectZero.html', {
          son_project_id: this.currCost.id,
          is_zero: this.currCost.is_zero == 2 ? 1 : 2,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.costShow = false
          this.currCost.is_zero = this.currCost.is_zero == 2 ? 1 : 2
          this.sonList.forEach((item) => {
            if (item.id == this.currCost.id) {
              item.is_zero = item.is_zero == 2 ? 1 : 2
            }
          })
          this.getProjectDetail(this.query.id)
        })
    },
    //修改项目动态
    setTimeForm(item) {
      console.log(item);
      const { bk_uid, create_time, event_id, id, info, bkUserArr } = item
      this.timeForm = {
        track_id: id,
        bk_uid,
        create_time,
        event_id,
        info,
        bkUserArr,
      }
    },
    handleCommand(command) {
      if (command == 'a') {
        this.timeForm = {
          track_id: '',
          bk_uid: '',
          create_time: '',
          event_id: '',
          info: '',
        }
        this.timeForm.option = 1
        this.timeForm.project_id = this.projectArr.id
        this.trackShow = true
      }
      else if (command == 'b') {
        delete this.timeForm.bkUserArr
        this.timeForm.option = 2
        this.trackShow = true
      }
      else if (command == 'c') {
        console.log('c');
        this.delTrackShow = true
      }
    },
    handleTrack() {
      this.$fly
        .post('apiProject_setTrackInfo.html', {
          ...this.timeForm,
          mType: this.mType,
        })
        .then((res) => {
          console.log(res);
          this.trackShow = false
          this.getProjectDetail(this.query.id)
        })
    },
    deleteTrack() {
      this.$fly
        .post('apiProject_delTrack.html', {
          track_id: this.timeForm.track_id,
          mType: this.mType,
        })
        .then(() => {
          this.delTrackShow = false
          this.getProjectDetail(this.query.id)
        })
    },
    //修改项目状态
    handleStatus() {
      this.$fly
        .post('ApiAdministrative_updateProjectDynamic.html', {
          project_id: this.query.id,
          client_id: this.projectArr.client_id,
          contract_type: this.projectArr.contract_type,
          contract_name: this.projectArr.contract_name,
          client_company: this.projectArr.client_company,
          brand: this.projectArr.brand,
          contract_amount: this.projectArr.contract_amount,
          parent_project_id: this.projectArr.parent_project_id,
          info: this.projectArr.info,
          option: 2,
          //以上内容必填
          status: this.currstatus,
          mType: this.mType,
        })
        .then(() => {
          this.statusShow = false
          this.$message.success('项目更新成功')
          this.getProjectDetail(this.query.id)
        })
    },
    //报错
    showWrongFn(word) {
      this.$message.error(word)
    },
    //点击复制
    clickCopy(msg) {
      const save = function (e) {
        e.clipboardData.setData('text/plain', msg.replace(/\s*/g, ""))
        e.preventDefault() // 阻止默认行为
      }
      const once = {
        once: true
      }
      document.addEventListener('copy', save, once) // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand('copy') // 执行copy方法
      this.$message({ message: '复制成功', type: 'success' })
    },
    //新增子项目内容
    fillSon() {
      this.$router.push({
        path: '/admin/son',
        query: { id: this.projectArr.id, mType: this.mType },
      })
    },
    //展示供应商
    showVendor(item) {
      // if (this.level == 6) {
      //   return false
      // }
      const { id, project_id, son_project_id, pay_type, vendorArr, budget_status, planList, contract_id } = item
      this.vendorForm = {
        pay_id: id,
        project_id,
        son_project_id,
        pay_type,
        vendor: vendorArr.vendor || '',
        vendor_id: vendorArr.id || '',
        budget_status,
        contract_id,//用来判断无合同情况
      }
      if (this.level != 1) {
        if (budget_status == '2') {
          this.$message.error('预算审核中不可更改供应商')
          return false
        }
        let flag = false
        if (planList) {
          planList.forEach((it) => {
            if (it.pay_check_status == '3') {
              return flag = true
            }
          })
        }
        if (flag) {
          this.$message.error('支付审核通过后不可修改供应商')
          return false
        }
      }
      this.vendorShow = true
      this.getVendorList(pay_type)
    },
    vendorChange(v) {
      this.vendorList.forEach(item => {
        if (item.id == v) {
          this.vendorForm = {
            ...this.vendorForm,
            vendor_id: item.id,
            vendor: item.vendor,
            contract_id: this.vendorForm.contract_id === '-1' ? this.vendorForm.contract_id : '',
          }
        }
      })
      const tempForm = JSON.parse(JSON.stringify(this.vendorForm))
      delete tempForm.budget_status
      delete tempForm.pay_type
      delete tempForm.vendor
      this.updatePayVendor(tempForm).then(res => {
        console.log(res);
        this.vendorShow = false
      })
    },
    getVendorList(pay_type) {
      this.$fly
        .post('apiPurchase_getVendorList.html', {
          per_page: 5000,
          type: pay_type == '2' ? '2' : '', //预支只能是个人
        })
        .then((res) => {
          this.vendorList = pay_type == '2' ? res.itemList.filter(item => item.is_staff == '1') : res.itemList
        })
    },
    //展示下载列表
    showNewVendor() {
      this.vendorShow = false
      this.newVendorShow = true
    },
    //展示供应商合同
    showPurchase(item) {
      if (!(this.mType == '2' ? this.NodeInclude('134') : this.NodeInclude('170'))) {
        this.$message.error("暂无权限");
        return false;
      }
      // if (this.level == 6) {
      //   return false
      // }
      const { id, project_id, son_project_id, pay_type, budget, vendorArr, budget_status, vendorContractArr, planList } = item
      this.vendorForm = {
        pay_id: id,
        project_id,
        son_project_id,
        pay_type,
        budget,
        vendor: vendorArr.vendor || '',
        vendor_id: vendorArr.id || '',
        budget_status,
        client_contract_name: this.projectArr.contract_name,
        contract_id: vendorContractArr.id || '',
      }
      if (this.level != 1) {
        if (vendorContractArr.contract_no && vendorContractArr.contract_no != 'TBD') {
          if (this.level != 1) {
            this.$message.error('已获取编号的合同不能更改')
            return false
          }
        }
        if (budget_status == '2') {
          this.$message.error('预算审核中不可更改供应商')
          return false
        }
        let flag = false
        if (planList) {
          planList.forEach((it) => {
            if (it.pay_check_status == '3') {
              return flag = true
            }
          })
        }
        if (flag && this.vendorForm.contract_id) {
          this.$message.error('支付审核通过后不可修改供应商合同')
          return false
        }
      }
      this.purchaseShow = true
      this.getPurchaseList(this.vendorForm)
    },
    getPurchaseList(postData) {
      const { client_contract_name } = postData
      this.$fly
        .post('apiPurchase_getContractList.html', {
          per_page: 5000,
          client_contract_name,
          mType: this.mType,
        })
        .then((res) => {
          this.purchaseList = res.itemList
        })
    },
    addPurchase(item) {
      this.$router.push({
        path: '/purchase/add',
        query: {
          pid: item.project_id,
          vid: item.vendor_id,
          kind: 1,
          payid: item.pay_id, //更新支付计划合同选择
          mType: this.mType,
        },
      })
    },
    purchaseChange(v) {
      this.purchaseList.forEach(item => {
        if (item.id == v) {
          this.vendorForm = {
            ...this.vendorForm,
            vendor: item.vendor,
            vendor_id: item.vendor_id,
            contract_id: item.id,
            contract_amount: item.contract_amount,
            vendor_type: item.vendor_type,
            contract_no: item.contract_no,
          }
        }
      })
      if ((this.vendorForm.pay_type == '2' && this.vendorForm.is_staff != '1') && this.vendorForm.vendor_type == '1') {
        console.log(this.vendorForm.pay_type, this.vendorForm.vendor_type);
        this.$message.error(`预支只能选择个人供应商`)
        this.purchaseShow = false
        return false
      }
      if (antiThousands(this.vendorForm.contract_amount) - antiThousands(this.vendorForm.budget) > 0) {
        this.$message.error(`合同金额不能大于预算`)
        this.purchaseShow = false
        return false
      }
      const tempForm = JSON.parse(JSON.stringify(this.vendorForm))
      delete tempForm.budget_status
      delete tempForm.pay_type
      delete tempForm.project_id
      delete tempForm.budget
      delete tempForm.is_staff
      delete tempForm.contract_amount
      delete tempForm.vendor_type
      delete tempForm.contract_no
      this.updatePayVendor(tempForm).then(res => {
        console.log(res);
        this.purchaseShow = false
      })
    },
    //更新支付计划的供应商
    updatePayVendor(tempForm) {
      return new Promise((resolve, reject) => {
        this.$fly
          .post('apiProject_addUpdatePay.html', {
            ...tempForm,
            mType: this.mType,
            option: 2,
          })
          .then((res) => {
            if (res.status === 200) {
              this.$message.success('支付计划已更新')
              this.query.id && this.getProjectDetail(this.query.id)
              resolve(res)
            }
            else {
              reject('fail')
            }
          })
      })
    },
    //更多
    handleCommandMore(command, row) {
      switch (command) {
        case "applyPayClick":
          this.applyPayClick(row);
          break;
        case "updatePayClick":
          this.updatePayClick(row);
          break;
        case "delClick":
          this.delClick(row);
          break;
        case "changeClick":
          this.changeClick(row);
          break;
        default:
          break;
      }
    },
    //合同申请
    contractApply() {
      this.getProjectDetail(this.query.id)
      setTimeout(() => {
        if (this.projectArr.application_init_time != '0000-00-00') {
          this.$message.error('立项申请已提交')
          return false
        }
        this.conShow = true
      }, 200);
    },
    handleConApply() {
      this.$fly
        .post('ApiAdministrative_addProjectInit.html', {
          project_id: this.query.id,
          mType: this.mType,
        })
        .then(() => {
          this.conShow = false
          this.$message.success('成功提交!')
          this.query.id && this.getProjectDetail(this.query.id)
        })
    },
    //获取项目变化
    getProjectNo() {
      if (this.projectArr.application_init_time == '0000-00-00') {
        this.$message.error('请先申请立项')
        return false
      }
      this.$fly
        .post('ApiAdministrative_getProjectCodeNo.html', {
          project_id: this.query.id,
          mType: this.mType,
        })
        .then(() => {
          this.$message.success('获取成功')
          this.query.id && this.getProjectDetail(this.query.id)
        })      
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  //标题样式
  @extend %box;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  padding: 20px 40px;
  margin-bottom: 10px;
  @extend %center;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;

  .header-info {
    width: 80%;
    @extend %center;
    align-items: flex-start;
    text-align: left;

    h1 {
      font: 700 28px/1 $font;
      margin-bottom: 16px;
    }

    p {
      font: 16px/2 $font;
    }
  }

  .header-status {
    @extend %center;
    flex-flow: row nowrap;

    .button {
      box-sizing: border-box;
      min-width: 100px;
      border-radius: 20px;
      padding: 10px 15px;
      font: 12px/1 $font;
      color: #fff;
    }
  }
}

.userdetail {
  .history {
    @extend %box;
    padding: 30px 40px;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    ul {
      @extend %start;
      color: #231f20;
      background: #f2f2f2;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }


        }
      }
    }
  }

  .table {
    @extend %box;
    padding: 20px 40px;
    margin-bottom: 20px;
    position: relative;

    ul {
      @extend %start;
      color: #231f20;
      background: #fff;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 40%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }


        }

        // &:last-child {
        //   width: 60%;
        //   box-sizing: border-box;
        //   padding-left: 85px;
        // }
      }
    }

    .for-title {
      font: 700 24px/1.5 $font;
      color: #444041;
    }

    .for {
      padding: 25px 0;

      &.grey {
        padding: 25px 20px;
        border-radius: 20px;
        background: #f2f2f2;
        margin-bottom: 20px;
      }

      ul {
        @extend %start;
        color: #231f20;
        background: #f2f2f2;
        padding: 0 25px;
        border-radius: 20px;
        margin-bottom: 20px;
        position: relative;

        &:last-of-type {
          margin-bottom: 0;
        }

        li {
          width: 40%;
          font: 14px/3 $font;

          p {
            height: 42px;
            @extend %start;

            label {
              width: 150px;
              white-space: nowrap;
              flex: none;
            }

            span {
              white-space: nowrap;
            }
          }

          // &:last-child {
          //   width: 60%;
          //   box-sizing: border-box;
          //   padding-left: 85px;
          // }
        }
      }

      .el-button {
        float: right;
        margin-bottom: 10px;
        position: relative;
      }
    }
  }

  .form {
    padding: 30px;
    margin-bottom: 0;
    box-shadow: none;
    border-radius: 20px;
    background: #f2f2f2;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        &:last-of-type {
          padding-left: 0;
          width: 60%;
        }

        .abtn {
          position: absolute;
          top: 0;
          left: 80%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 80%;
        }
      }
    }
  }
}

.linkwrap {
  font-size: 12px;
  position: relative;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }

  &.grey {
    color: #999;
  }

  .linkMore {
    position: absolute;
    right: 100px;
    @extend %center;
    width: 100px;

    >span {
      display: block;
      box-sizing: border-box;
      background: #fff;
    }
  }
}

.aul.ulist {
  // min-height: 480px;
  padding: 20px 0;
  font: 14px/2 $font;
  text-align: left;

  >li {
    padding: 0 60px;
    display: flex;
    flex-flow: row nowrap;

    span {
      display: inline-block;
      width: 50%;
    }
  }

  .ulform {
    padding: 0 60px;
  }

  .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}

.flex-box1,
.right {
  @extend %start;
  justify-content: space-between;
  align-items: center;

  .left {
    width: 80%;
  }

  .right {
    width: 20%;
    justify-content: flex-end;
  }
}

.switch {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.el-switch {
  font: 14px/20px $font;

  &.cursor {
    cursor: not-allowed;

    .el-switch__core {
      background-color: #999888;
      border-color: #999888;
      cursor: not-allowed;
    }
  }

  &.is-checked {
    cursor: not-allowed;

    &.super {
      .el-switch__core {
        cursor: pointer;
        background-color: #0E0F22;
        border-color: #0E0F22;

        &::before {
          font: 14px/20px $font;
          content: '是';
        }
      }
    }

    .el-switch__core {
      cursor: not-allowed;
      background-color: #999888;
      border-color: #999888;

      &::before {
        font: 14px/20px $font;
        content: '是';
      }
    }
  }

  .el-switch__core {
    background-color: #0E0F22;
    border-color: #0E0F22;

    &::before {
      font: 14px/20px $font;
      content: '否';
    }

    &::after {
      content: '';
    }
  }
}

.info-height {
  display: inline-block;
  // box-sizing: border-box;
  padding: 0px 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  max-height: 40px;
  overflow-x: hidden;
  //隐藏水平滚动条
  overflow-y: scroll;

  //隐藏垂直滚动条
  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.1);
  }

  /* 滚动条的滑轨背景颜色 */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.5);
  }

  /* 滑块颜色 */
}

.inblank {
  @extend %center;
  font: 14px/2 $font;
  color: #999;
  background: #f2f2f2;
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 20px;
  position: relative;
}

.operater {
  @extend %start;
  position: absolute;
  top: 30px;
  right: 40px;
  font: 14px/1 $font;
  text-align: center;

  >div {
    min-width: 32px;
    border: 1px solid #DCDFE6;
    border-radius: 3px;
    padding: 9px 10px;
    cursor: pointer;

    &.linkline {
      border-color: transparent;
      background: transparent;
      color: #231f20;

      &:hover {
        &::after {
          display: block;
          content: '';
          height: 0.1px;
          background: #231f20;
        }
      }
    }

    &.linkbox {
      border-color: #0E0F22;
      background: #0E0F22;
      color: #fff;

      &.grey {
        border-color: #c0c4cc;
        background: #c0c4cc;
        color: #fff !important;

        &:hover {
          background: #c0c4cc;
        }
      }

      &:hover {
        background: rgba($color: #0E0F22, $alpha: 0.8);
      }
    }
  }
}

.dialog-download {
  border-radius: 12px;
  background: #231f20;
  font: 12px/2 $font;
  color: #fff;
  padding: 5px 20px;
  margin: 0 20px;

  &:hover {
    color: #fff;
    background: rgba($color: #0E0F22, $alpha: 0.8);

    &::after {
      display: none;
    }
  }
}
</style>

<style lang="scss">
.linehead {
  //时间版头样式
  display: flex;
  flex-flow: row nowrap;
  font: 16px/1 $font;
  color: $c;
  padding: 25px 55px 0 60px;

  li {
    flex: auto;

    &:nth-child(1) {
      width: 190px;
      flex: none;
    }

    &:nth-child(2) {
      width: 190px;
      flex: none;
    }

    &:nth-child(3) {
      width: 190px;
      flex: none;
    }

    &:nth-child(4) {
      width: 880px;
      flex: none;
    }
  }
}

.timeline {
  //时间版内样式
  margin: 20px 25px 20px 30px;
  padding: 50px 30px;
  border-radius: 6px;
  border: solid 1px #bfbfbf;

  .ico-edit {
    display: block;
    width: 20px;
    height: 20px;
    z-index: 999 !important;
    position: absolute;
    left: -160px;
    top: 0px;
    cursor: pointer;

    ::before {
      font-size: 20px;
      width: 20px;
      height: 20px;
    }
  }

  .mycard {
    min-height: 80px;
    background-color: #f5f5f5;
    border-radius: 4px;
    padding: 0 20px;
    position: relative;
    transform: translateY(-20px);
    // pointer-events: none;

    &.parent {
      pointer-events: auto;
      // cursor: pointer;
    }

    &.active {
      background-color: #fff;
      height: 30px;

      &:before {
        display: none;
      }

      dl,
      .point {
        display: none;
      }
    }

    &:before {
      content: '';
      font-size: 0;
      border-bottom: 20px solid #f5f5f5;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid transparent;
      position: absolute;
      top: 0;
      left: -10px;
    }

    dl {
      flex: none;
      display: flex;
      height: 80px;
      flex-flow: column wrap;
      padding: 10px 60px 10px 00px;
      flex-flow: row nowrap;

      dd {
        height: 60px;
        width: 150px;

        &:nth-child(2) {
          width: 180px;
        }

        flex: none;
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: center;

        span {
          font: 14px/30px $font;
        }
      }
    }

    .ul {
      padding: 0;
      display: flex;
      flex-flow: row nowrap;
      position: relative;
      z-index: 999;

      li {
        @extend %center;
        align-items: flex-start;
        min-height: 80px;
        flex: auto;
        font: 14px/20px $font;

        &:nth-child(1) {
          width: 180px;
          flex: none;
        }

        &:nth-child(2) {
          width: 180px;
          flex: none;
        }

        &:nth-child(3) {
          padding-left: 20px;
          display: flex;
          flex-flow: column nowrap;
          padding: 10px 60px 10px 20px;
          box-sizing: border-box;
          text-align: left;

          span {
            font: 14px/30px $font;

            &.grey {
              font-size: 14px;
              color: #999;
            }
          }

          a {
            display: inline-block;
            position: relative;
            z-index: 999999999999999999 !important;
            cursor: pointer;
          }
        }
      }
    }

    .point {
      position: absolute;
      background: $c;
      color: #fff;
      height: 30px;
      font: 16px/30px $font;
      padding: 0 10px;
      border-radius: 15px;
      right: 30px;
      top: 25px;
    }

    .ticon {
      position: absolute;
      left: -160px;
      height: 30px;
      line-height: 30px;
      padding: 0 20px 0 88px;
      color: #fff;
      top: 14px;
    }
  }

  .el-timeline {
    padding-left: 140px;

    .el-timeline-item {
      position: relative;
    }
  }

  .child {
    .el-timeline-item__timestamp.is-top {
      background-color: #ffffff;
      color: #9c9a9a;
      text-align: right;
    }
  }

  .el-timeline-item__timestamp.is-top {
    position: absolute;
    left: -140px;
    width: 120px;
    height: 30px;
    background-color: #2696d2;
    border-radius: 4px;
    color: #fff;
    font: 14px/30px $font;
    padding: 0 0 0 10px;
    top: -6px;
    box-sizing: border-box;
  }
}

.pdou {
  span {
    &::after {
      content: ',';
      display: inline-block;
    }

    &:last-of-type {
      &::after {
        display: none;
      }
    }
  }
}
</style>
